import { StatisticsCards, RecentOrdersSection } from '../features/dashboard'
import { useAuthStore } from '../features/auth/store'
import { usePermissions, Permission } from '../shared/hooks/usePermissions'
import { useMerchant } from '../features/merchants/hooks/useMerchants'
import MerchantSessionRecordings from '../features/merchants/MerchantSessionRecordings'
import ErrorMonitoringPanel from '../features/dashboard/components/ErrorMonitoringPanel'

export const DashboardPage = () => {
  const { hasPermission } = usePermissions()
  // The active merchant: a merchant admin's own (from their JWT), or the merchant
  // a TCS admin has selected. Scopes the Clarity link to that merchant (PE-1830).
  const selectedTenantId = useAuthStore((state) => state.selectedTenantId)
  const canViewSessionRecordings = hasPermission(Permission.OBSERVABILITY_SESSION_RECORDINGS_VIEW)
  // Sentry error monitoring is TCS-admin-only (org-level, no merchant scoping).
  const canViewErrorMonitoring = hasPermission(Permission.OBSERVABILITY_ERROR_MONITORING_VIEW)
  // Resolve the merchant to read its Clarity project id. Watchman scopes this to
  // the caller's own merchant for MERCHANT roles, so a merchant admin only ever
  // sees their own. Fetch is skipped (hook `enabled: !!id`) when none is active.
  const { data: merchant } = useMerchant(
    canViewSessionRecordings ? (selectedTenantId ?? '') : '',
  )

  return (
    <div className="space-y-6 py-6">
      <StatisticsCards />
      {canViewSessionRecordings && selectedTenantId && (
        <MerchantSessionRecordings
          projectId={merchant?.clarityProjectId}
          merchantName={merchant?.name}
        />
      )}
      {canViewErrorMonitoring && <ErrorMonitoringPanel />}
      <RecentOrdersSection />
    </div>
  )
}
